import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { QNavWrapElem, QNavTitleElem, QNavListElem, QNavListItemElem, QNavAnchorElem } from './QuickNavigation.styles';

const QuickNavigation = ({ title, items, onItemClickCB }) => {
  return (
    <QNavWrapElem className="u-block-margins">
      <div className="container mx-auto px-4">
        <QNavTitleElem>{title}</QNavTitleElem>
        {items && (
          <QNavListElem>
            {items.slice(0, 4).map((item) => {
              const { linkText, id } = item;
              let url = '/';
              let linkTitle = '';

              if (item.page) {
                ({
                  page: { url, title: linkTitle },
                } = item);
              }

              const text = linkText || linkTitle;

              return (
                <QNavListItemElem key={`qNavListItem-${id}`}>
                  <Link href="/[...slug]" as={url} passHref>
                    <QNavAnchorElem onClick={() => onItemClickCB(text)}>{text}</QNavAnchorElem>
                  </Link>
                </QNavListItemElem>
              );
            })}
          </QNavListElem>
        )}
      </div>
    </QNavWrapElem>
  );
};

QuickNavigation.defaultProps = {
  onItemClickCB: () => {},
  items: [],
};

QuickNavigation.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      linkText: PropTypes.string,
      id: PropTypes.string.isRequired,
      page: PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }),
    }),
  ),
  onItemClickCB: PropTypes.func,
};

export default QuickNavigation;
